module.exports = __webpack_public_path__ + "static/media/oberflex-frakebariolet311-1200x2490.8c4457bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frakebariolet311-1200x2490.jpg
// module id = 1018
// module chunks = 37